module.exports = "/assets/data/7a4d46779bef6a0e3a82051a883ee81e-CO9.data.json";